<template>
<div class="tool-card pa-5">
  <div class="top-part">
    <span class="icon-part">
      <img class="quick-content-icon" src="/static/quick_content_icon_orange.svg" style="width:22px; height:22px;" />
    </span>
    <span class="name">Quick content orders</span>
   <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
  @click="() => {
    $store.commit('setCurrentVideoTutorialToDisplay', {
      title: 'Introducing Quick Content Orders',
      videoLink: 'https://www.youtube.com/embed/4mDSpwYnQCg',
      description: 'Introducing Quick Content Orders - the fastest way to get optimized content without the wait.\nIf you already know your keywords and target pages, skip the content audit and jump straight into ordering SEO-optimized content.\nIn this video, we’ll walk you through how to use the new Quick Content Orders feature inside POP White Glove.\n\n✅ No content audit required\n✅ Just paste your keywords\n✅ Get high-quality content - fast\n\nPerfect for SEOs, marketers, and agencies who want to streamline their workflow and get results quicker.',
      time: '4m 59s'
    });
  }">
  videocam
</span>
  </div>
  <!-- NOTE: The tab selector code below is commented-out in order to hide the Page tab -->

  <template v-if="!loading">
    <div class="mt-5" v-if="domainLevelCampaign && orderedSilos?.length">
      <v-text-field outlined dense
        v-model="searchTerm"
        hide-details="auto"
        label="Search"
        color="greenColor"
      />
    </div>
  
    <div class="flex flex-column flex-grow-1 pages-wrapper mt-3">
      <template>
        <div v-if="!orderedSilos?.length" style="flex:1; display: flex; flex-direction: column; justify-content: center;">
          <div>
            <div class="mainColor--text font-weight-bold mb-6" style="font-size: 1.6rem;">Order content<br/>quickly <img src="/static/flash_icon.png" style="width: 1.6rem; height: 1.6rem;" /></div>
            <div class="mainColor--text mb-6">Skip silo setup and get content written fast as part of your {{ $store.getters.isPopAuthorityUser ? 'POP Authority' : 'POP White Glove' }} subscription.</div>
            <v-btn
              @click="() => domainLevelCampaign ? gotoQuickContentOrders() : $refs.createDomainCampaignModalRef.showModalAction()"
              rounded small
              color="profileAnchorColor"
              class="button-with-icon whiteColor--text text-none"
            >
              Order content
            </v-btn>
          </div>
        </div>
        <template v-else>
          <div v-for="silo in filteredOrderedSilos" :key="silo.id" class="page-item" @click="() => {
            $router.push(`/sites/${siteId}/quick-content-orders?id=${silo.id}`)
          }">
            <div class="flex-grow-1">
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                  <div class="name" v-bind="attrs" v-on="on">Order #{{ silo.content_report_order.id }} ({{ countKeywords(silo?.content_report_order) }} {{ countKeywords(silo?.content_report_order) > 1 ? 'keywords' : 'keyword' }})</div>
                </template>
                <div style="max-width: 300px;">
                  {{ getOrderKeywords(silo).map(k => k.keyword).join(', ') }}
                </div>
              </v-tooltip>
              <div class="time">
                {{ toLocalDateString(silo.createdAt) }}
              </div>
            </div>
            <div class="action">
              <i class="material-icons-outlined" @click="() => {
                $router.push(`/sites/${siteId}/quick-content-orders?id=${silo.id}`)
              }">arrow_circle_right</i>
            </div>
          </div>
        </template>
      </template>
    </div>
  
    <div class="mt-5 d-flex align-center justify-space-between" v-if="domainLevelCampaign && orderedSilos?.length">
      <v-btn v-if="!$store.getters.isDemoUser" rounded small color="profileAnchorColor"
        class="button-with-icon whiteColor--text text-none"
        @click="gotoInsight">
        <span>Order content</span>
      </v-btn>
      <span class="how-many" @click="() => {
        $router.push(`/sites/${siteId}/quick-content-orders`)
      }">
        {{ orderedSilos.length }} {{ orderedSilos.length > 1 ? 'orders' : 'order' }}
      </span>
    </div>
  </template>

  <create-domain-level-campaign-modal
    ref="createDomainCampaignModalRef"
    modalTitle="Quick content orders"
    @success="() => gotoQuickContentOrders()"
  ></create-domain-level-campaign-modal>

</div>
</template>

<script>
import { mixin } from '@/components/mixin'
import CreateDomainLevelCampaignModal from '@/components/SitesSingleView/Tools/CreateDomainLevelCampaignModal.vue'

export default {
  mixins: [mixin, ],
  components: {
    CreateDomainLevelCampaignModal,
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    selectedSubAccountRelation () {
      return this.$store.state.selectedSubAccountRelation
    },
    siteId () {
      return parseInt(this.$route.params.siteId)
    },
    domainLevelCampaigns () {
      return this.campaigns.filter(item => item.isDomainLevelCampaign)
    },
    domainLevelCampaign () {
      if (this.domainLevelCampaigns.length > 0) {
        return this.domainLevelCampaigns[0]
      }
      return null
    },
    orderedSilos () {
      return this.silos.filter((silo) => ['paid', 'to_be_paid_by_invoice'].includes(silo?.content_report_order?.order_status));
    },
    filteredOrderedSilos () {
      return this.orderedSilos.filter((silo) => [
        `order #${silo.content_report_order.id}`,
        ...this.getOrderKeywords(silo).map(k => k.keyword)
      ].join(', ').includes(this.searchTerm.toLowerCase()))
    }
  },
  watch: {
    siteId: {
      handler: function (newVal, oldVal) {
        this.loadCampaigns()
        .then(() => this.loadSilos())
        .finally(() => {
          this.loading = false
        })
      },
      immediate: true,
    },
  },
  data () {
    return {
      loading: true,
      searchTerm: '',
      campaigns: [],
      silos: [],

    }
  },
  methods: {
    loadCampaigns () {
      return this.$store.dispatch('getCampaignsForSite', this.siteId)
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.campaigns = response.data.campaigns
        }
      })
    },
    loadSilos () {
      if (this.domainLevelCampaign) {
        this.$store.dispatch('getSilos', {
          campaignId: this.domainLevelCampaign.id,
          paginate: 0,
          isForQuickContentOrder: 1,
          includeKeywords: 1,
          includeAiAndPageRunResult: 0,
          includeGuardDiffData: 0,
          includePage: 0,
        })
        .then((response) => {
          this.silos = response.data.data;
        })
      }
    },
    countKeywords(order) {
      return (
        (order?.selected_supporting_keyword_ids?.length || 0)
        + (order?.selected_top_level_keyword_ids?.length || 0)
      )
    },
    getOrderKeywords(silo) {
      return silo.silo_keywords.filter(silo_keyword => [
        ...silo?.content_report_order?.selected_top_level_keyword_ids || [],
        ...silo?.content_report_order?.selected_supporting_keyword_ids || [],
      ].includes(silo_keyword.id))
    },
    gotoQuickContentOrders() {
      this.$router.push(
        `/sites/${this.siteId}/quick-content-orders`,
      );
    },
    gotoInsight() {
      const { siteId } = this.$route.params;
      this.$router.push(
        `/sites/${siteId}/campaign/${this.domainLevelCampaign.id}/keyword-insight?fromQuickContentOrdersTab=1`,
      );
    },
  },
  mounted () {
     
  }
}
</script>

<style lang="scss" scoped>
.custom-tabs {
  display: flex;
  background: var(--v-gray7Color-base);
  border-radius: 10px;
  padding: 3px;
  & > div {
    flex-basis: 35%;
    text-align: center;
    padding: 10px 10px;
    border-radius: 10px;
    cursor: pointer;
    color: var(--v-mainColor-base);
    font-weight: 700;

    &:first-child {
      flex: 1;
    }

    &.is-active {
      background: var(--v-whiteColor-base);
      box-shadow: 0px 3px 4px -1px #00000014;
    }
  }
}

.white-glove-site-content-audit-oboarding-tip {
  position: absolute;
  top: 32px;
  right: 40px;
}
</style>
